export default __webpack_public_path__ + "static/media/ELE47N.ca3f9656.png";